import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Menu, ExternalLink } from 'lucide-react';

const Header = () => {
  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'Technology', path: '/technology' },
    { name: 'Developers', path: '/developers' },
    { name: 'Tokenomics', path: '/tokenomics' },
    { name: 'Roadmap', path: '/roadmap' },
    { name: 'Whitepaper', path: '/whitepaper' },
  ];

  return (
    <motion.header
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ type: 'spring', stiffness: 120, damping: 14 }}
      className="fixed top-0 left-0 right-0 bg-black bg-opacity-90 backdrop-blur-md z-50 border-b border-white"
    >
      <nav className="container mx-auto px-4 py-4 flex justify-between items-center">
        <Link to="/" className="text-2xl font-bold text-white flex items-center gap-2">
          <span className="text-3xl">◉</span>
          <span>AVO</span>
        </Link>
        
        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center space-x-6">
          {navItems.map((item) => (
            <Link
              key={item.name}
              to={item.path}
              className="text-gray-300 hover:text-white transition-colors duration-300 relative group"
            >
              {item.name}
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-white transition-all duration-300 group-hover:w-full"></span>
            </Link>
          ))}
          
          {/* Action Buttons */}
          <a
            href="http://localhost:3000"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 bg-white text-black px-4 py-2 rounded-none font-semibold hover:bg-gray-200 transition-colors duration-300"
          >
            Explorer <ExternalLink size={16} />
          </a>
          <a
            href="http://localhost:3001"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 bg-transparent border-2 border-white text-white px-4 py-2 rounded-none font-semibold hover:bg-white hover:text-black transition-all duration-300"
          >
            AVO Station <ExternalLink size={16} />
          </a>
        </div>
        
        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <button className="text-gray-300 hover:text-white">
            <Menu size={24} />
          </button>
        </div>
      </nav>
    </motion.header>
  );
};

export default Header;